export var VatRegistrationSubscriptionEventType = /* @__PURE__ */ ((VatRegistrationSubscriptionEventType2) => {
  VatRegistrationSubscriptionEventType2["ESLTaxReturnType"] = "ESLTaxReturnType";
  VatRegistrationSubscriptionEventType2["VLSTaxReturnType"] = "VLSTaxReturnType";
  return VatRegistrationSubscriptionEventType2;
})(VatRegistrationSubscriptionEventType || {});
